export default {
    0: '超管',
    1: '进入零售后台',  // 零售后台权限
    2: '进入收银台',
    3: '店铺数据',
    4: '会员管理',
    5: '店铺设置',
    6: '添加员工',
    7: '删除员工',
    8: '编辑/配置角色',
    9: '订单退款',
    10: '添加/删除商品',
    11: '商品上/下架',
    12: '收银台改价',  // 收银台权限
    13: '订单减免',
    14: '收银台退款',
    15: '订单折扣',
    16: '订单抹零',
    29: '查看收银数据',
    17: '进入App权限',  // app 权限
    18: '店铺数据',
    19: '编辑手工会员',
    20: '店铺设置',
    21: '添加员工',
    22: '删除员工',
    23: '编辑/配置角色',
    24: '订单退款',
    25: '添加/删除商品',
    26: '商品上/下架',
    28: '删除手工会员',
}
